import { openBlock as t, createElementBlock as l, createElementVNode as e } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, a = /* @__PURE__ */ e("g", { "clip-path": "url(#a)" }, [
  /* @__PURE__ */ e("path", {
    "fill-rule": "evenodd",
    d: "M13.5 1.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Zm-2.25.75a2.25 2.25 0 1 1 2.29 2.25l-1.658 4.975a2.25 2.25 0 1 1-3.413.805.755.755 0 0 1-.093-.114l-1.92-2.879a2.225 2.225 0 0 1-.948.213l-1.599 3.996a2.25 2.25 0 1 1-1.417-.496l1.599-3.996a2.25 2.25 0 1 1 3.44-.784.755.755 0 0 1 .093.114l1.92 2.879a2.24 2.24 0 0 1 .915-.213l1.659-4.975A2.246 2.246 0 0 1 11.25 2.5ZM5.5 4.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Zm5 6a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Zm-8 2a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Z",
    "clip-rule": "evenodd"
  })
], -1), n = /* @__PURE__ */ e("defs", null, [
  /* @__PURE__ */ e("clipPath", { id: "a" }, [
    /* @__PURE__ */ e("path", { d: "M0 0h16v16H0z" })
  ])
], -1), r = [
  a,
  n
];
function c(d, s) {
  return t(), l("svg", o, [...r]);
}
const p = { render: c };
export {
  p as default,
  c as render
};
